module.exports = [{
      plugin: require('/Users/setFloat/Projects/aftergalvanize/drivepricer/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
